import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgToggleOff = (props: PropsType) => {
  return (
    <svg
      width='29'
      height='14'
      viewBox='0 0 29 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M7.02577 14C5.07425 14 3.41535 13.3204 2.04906 11.9611C0.68302 10.6015 0 8.95082 0 7.00894C0 5.06681 0.68302 3.41312 2.04906 2.04787C3.41535 0.682624 5.07425 0 7.02577 0H21.9742C23.9257 0 25.5847 0.679646 26.9509 2.03894C28.317 3.39848 29 5.04918 29 6.99106C29 8.93319 28.317 10.5869 26.9509 11.9521C25.5847 13.3174 23.9257 14 21.9742 14H7.02577ZM7.02577 12.9574H21.9742C23.6186 12.9574 25.0262 12.3741 26.1972 11.2074C27.3681 10.0408 27.9536 8.6383 27.9536 7C27.9536 5.3617 27.3681 3.95922 26.1972 2.79255C25.0262 1.62589 23.6186 1.04255 21.9742 1.04255H7.02577C5.38144 1.04255 3.9738 1.62589 2.80283 2.79255C1.63187 3.95922 1.04639 5.3617 1.04639 7C1.04639 8.6383 1.63187 10.0408 2.80283 11.2074C3.9738 12.3741 5.38144 12.9574 7.02577 12.9574ZM7.02129 10.5C7.99593 10.5 8.82582 10.1602 9.51095 9.48053C10.1961 8.80089 10.5387 7.97553 10.5387 7.00447C10.5387 6.0334 10.1976 5.20656 9.51544 4.52394C8.83329 3.84131 8.0049 3.5 7.03026 3.5C6.05562 3.5 5.22573 3.83982 4.54059 4.51947C3.85546 5.19911 3.51289 6.02447 3.51289 6.99553C3.51289 7.9666 3.85396 8.79344 4.53611 9.47606C5.21826 10.1587 6.04665 10.5 7.02129 10.5Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgToggleOff;
